import { Notify, Response } from 'application/Shared/Helpers';
import { WelcomeEmail } from 'application/Shared/Requests';
import { debug } from 'application/Shared/Utils';
import axios from 'axios';
import i18n from 'i18n';

const { t } = i18n;

const { isSuccessCode, getData, hasData } = Response;

const addLegacyUsers = async (emails, permissionId, clientId) => {
    const payload = emails.map((email) => ({
        email,
        firstName: email,
        lastName: '',
        permissionId,
        platformTenantId: clientId,
        tenantUserId: email
    }));

    try {
        await axios.post('/user/bulk', payload);
    } catch (e) {
        throw new Error(e);
    }
};

const addNonLegacyUsers = async (emails, clientId, userId, permissionId) => {
    // If all the users that were invited are filtered out then we don't need to add them
    if (emails.length === 0) return [[], 200];

    const payload = emails.map((email) => ({
        email,
        invitedBy: userId,
        permissionId,
        platformTenantId: clientId
    }));

    let respData;
    let respCode = 201;
    try {
        respData = await axios.post('/invitation', payload);
    } catch (e) {
        debug.e(e.toString());
        respData = [];
        respCode = 500;
    }

    return [respData, respCode];
};

export const inviteUsers = async ({
    clientId,
    existingUsers,
    isANM,
    onClose,
    platformTenantId,
    rerender,
    session,
    userId,
    values
}) => {
    const welcomeEmailFunction = new WelcomeEmail();
    const keys = Object.keys(values);

    const permissionId = values.role;
    let emails = [];
    for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i];
        if (key.includes('email')) {
            emails.push(values[key]?.toLowerCase());
        }
    }

    let response;
    let respCode;
    try {
        // Tenant is a non legacy user and invitation is at the partner level
        if (isANM && !clientId) {
            // Filter out existing users from the email list
            const existingUserEmails = existingUsers.map((u) => u.email);
            emails = emails.filter((e) => !existingUserEmails.includes(e));

            [response, respCode] = await addNonLegacyUsers(
                emails,
                platformTenantId,
                userId,
                permissionId
            );

            if (
                !isSuccessCode(respCode) ||
                !hasData(response, { noId: true })
            ) {
                throw new Error(t('Users.invite.invitationFail'));
            }

            const data = getData(response, { noId: true });
            const successfulInvites = data
                .filter((d) => d.success)
                .map((d) => d.email);
            const failedInvites = data
                .filter((d) => !d.success)
                .map((d) => d.email);

            await welcomeEmailFunction.sendWelcomeEmail({
                emails: successfulInvites,
                session,
                t
            });

            if (failedInvites.length) {
                Notify.e(
                    t('Users.invite.emailFail', {
                        emails: failedInvites.join(', ')
                    }),
                    { seconds: 5 }
                );
            } else {
                Notify.s(t('Users.invite.successSent'));
            }
        } else {
            await addLegacyUsers(emails, permissionId, clientId);
            await welcomeEmailFunction.sendWelcomeEmail({
                clientId,
                emails,
                session,
                t
            });

            Notify.s(t('Users.invite.successSent'));
        }

        rerender();
        onClose();
    } catch (err) {
        debug.e(t('Users.invite.invitationFail'), err.toString());
        Notify.e(t('Users.invite.invitationFail'));
    }
};
